import React from 'react'
import { authorization } from 'Module/Auth/Auth'
import { getCityLink } from 'Utils/Link'
import { PageTitle } from 'Components/PageTitle'
import { LayoutDashboard } from 'Components/Layout/Dashboard'
import { CityAddEditWrapper } from 'Components/City/CityAddEdit/Wrapper'
import { EditCityView } from '../../../Containers/Form/City/CityAddEdit/EditCityView'
import { HideWhenBlocked } from 'Containers/UIBlock/HideWhenBlocked'
import { PATHS } from 'Config/Routing/paths'
import CitiesIcon from 'Assets/Images/icons/cities'
import { SectionWrapper } from '../../../Components/Section/SectionWrapper'
import BadWeather from '../../../Containers/Form/City/BadWeather'
import LoadingIndicator from '../../../Components/LoadingIndicator/LoadingIndicator'
import CityPromoCampaign from '../../Form/City/CityPrograms/CityPrograms/Promo'
import CityReferralCampaign from '../../Form/City/CityPrograms/CityPrograms/Referral'
import StyledBreadcrumbs from '../../../Components/StyledBreadcrumbs'

const CityEdit = props => {
  if (!props.cityDataLoaded) return <LoadingIndicator />

  const isAdmin = authorization.isAdmin()

  return (
    <HideWhenBlocked>
      <CityAddEditWrapper>
        <LayoutDashboard>
          <StyledBreadcrumbs
            icon={<CitiesIcon style={{ width: 16 }} />}
            breadcrumbs={[
              {
                label: 'Cities',
                link: `${PATHS.main.dashboard}${PATHS.dashboard.cities}`,
              },
              {
                label: props.cityName,
                link: getCityLink(props.cityId, ' '),
              },
              {
                label: 'Edit',
              },
            ]}
          />
          <PageTitle>Edit City</PageTitle>
          <EditCityView {...props} />
          {isAdmin && (
            <SectionWrapper className="section-wrapper">
              <BadWeather cityId={props.cityId} />
            </SectionWrapper>
          )}
          {isAdmin && (
            <SectionWrapper className="section-wrapper">
              <CityReferralCampaign cityId={props.cityId} />
            </SectionWrapper>
          )}
          {isAdmin && (
            <SectionWrapper className="section-wrapper">
              <CityPromoCampaign cityId={props.cityId} />
            </SectionWrapper>
          )}
        </LayoutDashboard>
      </CityAddEditWrapper>
    </HideWhenBlocked>
  )
}

export { CityEdit }
